<!-- app.component.html -->
<div class="container-fluid">
  <!-- HEADER -->
  <app-header 
      (click)="closeNavbar()" 
      (keydown.enter)="closeNavbar()"
      class="header"
      >
  </app-header>

  <!-- BACKDROP NAVBAR -->
  <div (keydown.enter)="closeNavbar()" [class]="isBackdropVisible() ? 'backdrop-navbar' : ''" (click)="closeNavbar()">
  </div>
  <div class="main-content-wrapper">
    <!-- NAVBAR -->

    <!-- MAIN CONTENT -->
    <div class="main">
      <div class="navbar-conte">
        <app-navbar (isNavbarOpened)="isNavbarOpen($event)" [closeNavbar]="isBackdropVisible()"></app-navbar>
      </div>
      <div class="main-content">
        <router-outlet></router-outlet>
        @if(routerServiceConte.showGoBackButton()){
          <div class="d-flex justify-content-end p-5">
            <button class="btn btn-primary mt-5 mb-3 ms-3" type="button"
              (click)="routerServiceConte.redirectToSpecificSection(); triggerIndietro()"
              >
              Indietro
            </button>
          </div>
        }
      </div>
      <!-- FOOTER -->
      <app-footer class="bg-primary footer"></app-footer>
    </div>
  </div>
</div>
<cdc-download-manager
  [downloads]="zipJobsService.downloads()"
  (retryDownload)="zipJobsService.retry($event.id)"
  (removeDownload)="zipJobsService.remove($event.id)"
  (downloadAgain)="zipJobsService.downloadAgain($event.id)"
></cdc-download-manager>